module.exports = __webpack_public_path__ + "static/img/20250327002.419c701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250327002.jpg
// module id = sMB6
// module chunks = 0